<script setup lang="ts">
  import type { SupportSession } from '@gat-ship/types'
  import { Badge } from '@gat-ship/vue-components'
  import { IconCheckFilled, IconHourglass } from '@gat-ship/icons'
  import { useSupportSessionCountdown } from '../../composables/useSupportSessionCountdown'

  defineOptions({
    inheritAttrs: false
  })

  const props = defineProps<{
    /** The date the session was granted to ISO string */
    grantedTo: SupportSession['grantedTo']
  }>()

  const { isExpired, label } = useSupportSessionCountdown(() => props.grantedTo)
</script>

<template>
  <Badge
    class="flex w-fit items-center justify-start gap-1 p-1 px-2"
    :class="{ 'bg-success/15 ring-0': isExpired }"
    variant="outline"
  >
    <IconCheckFilled v-if="isExpired" class="size-4" />
    <IconHourglass v-else class="size-4" />
    <span>{{ label }}</span>
  </Badge>
</template>
